import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ApplicationsLayer from "../components/ApplicationsLayer";

const ApplicationsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Applications" />
        <ApplicationsLayer />
      </MasterLayout>
    </>
  );
};

export default ApplicationsPage;
